export default {"src":"/_next/static/media/aer-lingus-logo-mobile.d89bc16c.svg","height":40,"width":100,"blurWidth":0,"blurHeight":0};